// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__264h8","noInteraction":"EventWrapper_noInteraction__2cjXL"};